import { atomWithReset, useResetAtom } from 'jotai/utils';

export const hasPushNotificationsEnabledAtom = atomWithReset<boolean>(false);

export function useResetNotificationsAtoms() {
  const resetHasPushNotificationsEnabled = useResetAtom(hasPushNotificationsEnabledAtom);
  return () => {
    resetHasPushNotificationsEnabled();
  };
}
